<div class="h-100 d-flex flex-column">
  <div class="note-toolbar">
    <button mat-icon-button class="note-toolbar__back" (click)="backToMainMenu()" [matTooltip]="'Home.Header.Back' | translate">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="note-toolbar__title">
      {{ 'Home.Header.NoteButton' | translate }}
      <span class="note-toolbar__count">{{ notes.length }}/{{ totalLength }}</span>
    </span>
    <div class="d-flex align-items-center gap-2">
      <button matMiniFab class="note-toolbar__add" (click)="createNote()" [matTooltip]="'Notes.Create' | translate">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div class="filter-row">
    <ui-input [compact]="true" prefixIcon="filter" [(ngModel)]="searchInput" (valueChange)="search()" [placeholder]="'Global.Filter' | translate" />
    <app-language-selector [showLabel]="false" />
  </div>
  <div class="note-list flex-1" (scroll)="onScroll($event)">
    @for (note of notes; track note._id) {
      <div class="note-item" [class.note-item--selected]="note._id === currentNoteId" (click)="router.navigateByUrl('/notes/' + note._id)">
        <div class="note-item__icon">
          <mat-icon>article</mat-icon>
        </div>

        <div class="note-item__content" [matTooltip]="note.name + (note.description ? '\n' + note.description : '')" matTooltipClass="multiline-tooltip">
          <span class="note-item__title">{{ note.name }}</span>
          @if (note.description) {
            <span class="note-item__description">{{ note.description }}</span>
          }
          @if (note.createdAt || note.createAt) {
            <div class="note-item__tags">
              <span class="note-item__tag">{{ note.createdAt || note.createAt | date: 'yyyy-MM-dd HH:mm' }}</span>
            </div>
          }
        </div>

        <button mat-icon-button #optionsBtn class="note-item__options" (click)="openNoteMenu($event, optionsBtn, note)" aria-label="More options">
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
    }

    <div #scrollObserver class="scroll-observer"></div>

    @if (loading) {
      @if (notes.length === 0) {
        <ui-skeleton type="note-list" [noPadding]="true" />
      } @else {
        <ui-skeleton type="note-list" [noPadding]="true" [count]="2" />
      }
    }
  </div>
</div>
